module.exports = __webpack_public_path__ + "img/license.83c101a9.jpg";